import {
  extractOnlyNumbers,
  removeMultipleSpace,
  removeSpecialCharAndNumFn,
  removeUnderScrSpCharSpaceBet,
  sliceText,
} from "../../../utils/common";
import { safeString } from "../../../utils/logger";

export const BANKING_INITIAL_STATE = {
  bank_name: "",
  branch_name: "",
  account_no: "",
  ifsc_no: "",
  account_type: "",
  is_primary: true,
  is_force_primary: false,
};

export const BANK_INPUT_FIELDS = {
  bank_name: {
    name: "bank_name",
    fullWidth: true,
    label: "Bank Name",
    placeholder: "Type Here...",
    type: "text",
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeSpecialCharAndNumFn(safeString(value), 150));

        return value;
      },
    },
  },
  branch_name: {
    name: "branch_name",
    fullWidth: true,
    label: "Branch Name",
    placeholder: "Type Here...",
    type: "text",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value), 150));
        return value;
      },
    },
    required: true,
  },
  account_no: {
    required: true,
    name: "account_no",
    fullWidth: true,
    label: "Account No",
    placeholder: "Type Here...",
    type: "tel",
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(extractOnlyNumbers(value), 18);
      },
    },
  },
  ifsc_no: {
    required: true,
    name: "ifsc_no",
    fullWidth: true,
    label: "IFSC No",
    placeholder: "Type Here...",
    type: "tel",
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(removeUnderScrSpCharSpaceBet(value).toUpperCase(), 11);
      },
    },
  },
  account_type: {
    required: true,
    name: "account_type",
    fullWidth: true,
    label: "Account Type",
    placeholder: "Select Here...",
    type: "select",
    options: [
      { id: "current", name: "Current" },
      { id: "savings", name: "Savings" },

    
    ],
  },
  is_primary: {
    name: "is_primary",
    label: "Primary Account",
    placeholder: "Select Here...",
    type: "checkbox",
    lableFirst: true,
    color: "Primary",
    size: "lg",
  },
  is_force_primary: {
    name: "is_force_primary",
    label: "Force Primary Account",
    placeholder: "Select Here...",
    type: "checkbox",
    lableFirst: true,
    color: "Primary",
    size: "lg",
  },
};

export const BANKING_API = {
  BANKING_CREATE: { url: "/organization/create-org-bank/", method: "POST" },
  BANKING_UPDATE: { url: "/organization/modify-org-bank/", method: "POST" },
  BANKING_DELETE: { url: "/organization/org-bank/", method: "DELETE" },
  BANKING_LIST: { url: "/organization/org-bank/", method: "GET" },
  MASTER_BANKING_LIST: {
    url: "/organization/org-bank/admin/master",
    method: "GET",
  },
};

export const BANKING_TABLE_HEADER = [
  { key: "slNo", label: "SL No.", isShortable: true, isVisible: true },
  // { key: "ecode", label: "Employee Code", isClickable: true, isShortable: true, isVisible: true },
  {
    key: "bank_name",
    label: "Bank Name",
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    isClickable: true,
  },
  {
    key: "branch_name",
    label: "Branch Name",
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
  },
  {
    key: "account_no",
    label: "Account No",
    align: "left",
    isShortable: false,
    isVisible: false,
  },
  {
    key: "account_type",
    label: "Account Type",
    align: "left",
    isShortable: false,
    isVisible: true,
  },
  {
    key: "ifsc_no",
    label: "IFSC No",
    align: "left",
    isShortable: false,
    isVisible: false,
  },

  {
    key: "status",
    label: "Primary Bank",
    align: "left",
    isClickable: false,
    isShortable: true,
    isVisible: false,
  },
];